
import { Component, Vue } from 'vue-property-decorator';
import { sendResetPasswordEmail } from '@/api/auth';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import EmailInput from '~/components/Inputs/Email.vue';
import emailValidator from '~/validators/email_address';

@Component({
  components: {
    CustomButton,
    CustomDialog,
    EmailInput
  }
})
export default class ResetPasswordDialog extends Vue {
  email = '';

  loading = false;

  sent = false;

  get buttonDisabled() {
    return !emailValidator(this.email) || this.loading;
  }

  async submit() {
    this.loading = true;

    try {
      await sendResetPasswordEmail(this.email);
    } finally {
      this.sent = true;
      this.loading = false;
    }
  }
}
